import { render, staticRenderFns } from "./ServiceLibraryTable.vue?vue&type=template&id=053008d7"
import script from "./ServiceLibraryTable.vue?vue&type=script&lang=js"
export * from "./ServiceLibraryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports